import  { useEffect, useState } from "react";
import Maqraha from "@/assets/optimized-images/maqraah.jpg";
import { contents } from "../../components/Data/datas";
import { FaStar } from "react-icons/fa6";

const AboutUs = () => {
  const [toggle, setToggle] = useState(1);
  const [direction, setDirection] = useState("next");
  const [isAnimating, setIsAnimating] = useState(false);
  const [prevToggle, setPrevToggle] = useState(null);

  const handleSlide = (id) => {
    if (isAnimating) return;
    setPrevToggle(toggle);
    setDirection(id > toggle ? "next" : "prev");
    setToggle(id);
  };

  useEffect(() => {
    const Interval = setInterval(() => {
      if (!isAnimating) {
        setPrevToggle(toggle);
        setDirection("next");
        toggle < contents.length ? setToggle(toggle + 1) : setToggle(1);
      }
    }, 3000);

    return () => clearInterval(Interval);
  }, [toggle, isAnimating]);

  const handleAnimationStart = () => {
    setIsAnimating(true);
  };

  const handleAnimationEnd = () => {
    setIsAnimating(false);
  };

  return (
    <div>
      <div className="bg-no-repeat bg-AdviceBg font-[Inter] bg-cover relative mb-20">
        <div className="absolute inset-0 bg-[#000000CF]"></div>
        <div className="relative z-10">

        <div className="transform px-6 p-20 sm:p-28 flex flex-col items-center gap-8 text-white text-center">
          <h2 className="font-bold leading-[0.65] sm:leading-6 text-6xl">
            About Us
          </h2>
        </div>
            </div>
      </div>
      <div className="p-5 sm:pt-2 sm:px-20 pt-20 flex gap-5 gap-x-16 flex-col sm:flex-row">
        <div className="w-full">
          <img src={Maqraha} alt="Maqraha" className="w-full" />
        </div>
        <div className="space-y-5 w-full sm:px-7">
          <div className="h-1 w-14 bg-[#3b76db]"></div>
          <h2 className="font-[Roboto] text-6xl font-bold">About Us</h2>
          <p>
            <b>
              Maqrahaatu Tanzeel is an online institute dedicated to helping
              Muslims worldwide memorize the Quran and master various styles of
              Qira'at with ease. Our mission is to make Quranic learning
              accessible, structured, and spiritually fulfilling.
            </b>{" "}
            Join a Global Learning Community With 10,000+ students from 10+
            Islamic countries, we provide a supportive and engaging environment
            where learners of all levels can thrive.
          </p>
          <ul>
            <p>Why Choose Maqrahaatu Tanzeel?</p>
            <li>
              <b>Expert Instructors –</b> Learn from qualified teachers with
              deep knowledge of Tajweed and Qira'at.
            </li>
            <li>
              {" "}
              <b>Flexible Online Learning –</b>
              Study at your own pace from anywhere in the world.
            </li>
            <li>
              <b>Personalized Memorization Plans –</b>
              Tailored guidance to help you achieve your Quranic goals.
            </li>
            <li>
              <b>Master Qira'at –</b> Explore different recitation styles and
              improve fluency.
            </li>
          </ul>

          <p>
            Join us today and embark on a life-changing journey with the Quran!
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-5">
        <div className="grid gap-2 grid-cols-[1fr_auto_1fr] p-3 sm:px-10">
          <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
          <FaStar className="text-4xl text-[#3b76db]" />
          <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
        </div>

        <div className="px-10 relative overflow-hidden h-96">
          {contents.map((content) => (
            <div
              key={content.id}
              className={`absolute w-full h-full transition-all duration-1000 ease-in-out ${
                content.id === toggle ? "z-10" : "z-0"
              }`}
              style={{
                transform:
                  content.id === toggle
                    ? "translateX(0)"
                    : content.id === prevToggle && direction === "next"
                    ? "translateX(-100%)"
                    : content.id === prevToggle && direction === "prev"
                    ? "translateX(100%)"
                    : direction === "next"
                    ? "translateX(100%)"
                    : "translateX(-100%)",
                opacity: content.id === toggle ? 1 : 0,
              }}
              onTransitionStart={handleAnimationStart}
              onTransitionEnd={handleAnimationEnd}
            >
              <img
                src={content.image}
                alt={`Content ${content.id}`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>

        <div className="flex gap-3 justify-center">
          {contents.map((content) => (
            <button
              key={content.id}
              onClick={() => handleSlide(content.id)}
              className={`${
                content.id === toggle ? "bg-[#66B2FF]" : "bg-gray-400"
              } rounded-full outline-none border-none sm:p-[0.3rem] p-[0.2rem] transform mt-2 transition-all duration-300`}
              aria-label={`View content ${content.id}`}
              disabled={isAnimating}
            ></button>
          ))}
        </div>

        <div className="grid gap-2 grid-cols-[1fr_auto_1fr] p-3 sm:px-10">
          <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
          <FaStar className="text-4xl text-[#3b76db]" />
          <div className="bg-[#004C97] h-[0.1rem] self-center"></div>
        </div>
      </div>
      </div>

  );
};

export default AboutUs;
